var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('mail-builders-form-edit',{ref:"form",attrs:{"mail_builder_template_type":_vm.mail_builder_template_type}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }